import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import SignIn from "@/pages/SignIn";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import NewIdea from "@/pages/NewIdea";
import IdeaChat from "@/pages/IdeaChat";
import Verdict from "@/pages/Verdict";
import Documents from "@/pages/Documents";
import Plan from "@/pages/Plan";
import ExecutiveDashboard from "@/pages/ExecutiveDashboard";
import Formatter from "@/pages/Formatter";
import IntakeRead from "@/pages/IntakeRead";
import IntakeReads from "@/pages/IntakeReads";
import RingThreeGraduation from "@/pages/RingThreeGraduation";
import RingFourWelcome from "@/pages/RingFourWelcome";
import Admin from "@/pages/Admin";
import { AdminDossierList, AdminDossierDetail } from "@/pages/AdminDossiers";
import { Toaster } from "sonner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-14 font-mono text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  return (
    <Routes>
      <Route path="/" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/signin" element={<PublicOnly><SignIn /></PublicOnly>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/formatter" element={<Formatter />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/intake-read" element={<Protected><IntakeRead /></Protected>} />
      <Route path="/intake-read/:id" element={<Protected><IntakeRead /></Protected>} />
      <Route path="/intake-reads" element={<Protected><IntakeReads /></Protected>} />
      <Route path="/ideas/new" element={<Protected><NewIdea /></Protected>} />
      <Route path="/ideas/:id" element={<Protected><IdeaChat /></Protected>} />
      <Route path="/ideas/:id/graduation" element={<Protected><RingThreeGraduation /></Protected>} />
      <Route path="/ideas/:id/ring4-welcome" element={<Protected><RingFourWelcome /></Protected>} />
      <Route path="/ideas/:id/verdict" element={<Protected><Verdict /></Protected>} />
      <Route path="/ideas/:id/documents" element={<Protected><Documents /></Protected>} />
      <Route path="/ideas/:id/plan" element={<Protected><Plan /></Protected>} />
      <Route path="/ideas/:id/dashboard" element={<Protected><ExecutiveDashboard /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/admin/dossiers" element={<Protected><AdminDossierList /></Protected>} />
      <Route path="/admin/dossiers/:ideaId" element={<Protected><AdminDossierDetail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-14 font-mono text-zinc-500">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
        <Toaster theme="light" position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
